import {Typography} from 'components/Typography';
import {FC} from 'react';
import style from './style.module.scss';
import {Tooltip} from 'components/Tooltip';
import classNames from 'classnames';
import Icon from 'components/Icon';

interface IProps {
    isAnimated?: boolean;
    isSmall?: boolean;
}

export const OnlineEcomLabel: FC<IProps> = ({isAnimated, isSmall = true}) => {
    return (
        <Tooltip
            childrenClassName={style.tooltipOnlineEcom}
            overlay={
                <div className={style.tooltipOnlineEcomContent}>
                    <Typography variant={'label-12-r'}>Скидка действует только на сайте и в приложении</Typography>
                </div>
            }
        >
            <div
                className={classNames(style.onlineEcomBlock, {
                    [style.small]: isSmall,
                })}
            >
                <div
                    className={classNames(style.onlineEcomWrap, {
                        [style.small]: isSmall,
                    })}
                >
                    <div
                        className={classNames(style.onlineEcomPercentBg, {
                            [style.onlineEcomPercentBgAnimation]: isAnimated,
                        })}
                    />
                    <Icon icon={'percent-online'} width={13} height={13} className={style.onlineEcomPercent} />
                </div>
                <Typography
                    className={style.onlineEcom}
                    element={'div'}
                    variant={isSmall ? 'label-10-b' : 'label-12-r'}
                >
                    Скидка онлайн
                </Typography>
            </div>
        </Tooltip>
    );
};
